import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-shipment-upload-validation-show',
  templateUrl: './shipment-upload-validation-show.component.html',
  styleUrls: ['./shipment-upload-validation-show.component.scss'],
})
export class ShipmentUploadValidationShowComponent {
  @Input() fileErrors;
  @Input() type;
  panelOpenState: boolean = false;

  getErrors(combinedErrors, index) {
    if (this.type === 'address') {
      return `Row: ${combinedErrors?.address_id}, Address Type: ${combinedErrors?.address_type}`;
    } else {
      return combinedErrors.shipperReference
        ? `${index + 1}. Shipper Reference : ${combinedErrors?.shipperReference}`
        : combinedErrors;
    }
  }
}
